/**
 * LA REGLE DE FIN D'UN APPEL, COTE POSTE — « UN SEUL RESTANT = L'APPEL SE FERME ».
 *
 * Un appel ne reste actif que tant qu'il y a au moins DEUX personnes dedans :
 *   - a deux : l'autre part, il ne reste que moi -> l'appel se ferme tout seul ;
 *   - a trois ou plus : l'une part, il en reste au moins deux -> l'appel reste actif.
 *
 * Elle se lit sur les personnes REELLEMENT connectees a la salle (le media), pas sur l'etat que le serveur
 * relaie : elle marche donc meme quand l'API ne repond plus, et ne depend d'aucun polling.
 *
 * « Il ne reste que moi » ne ferme l'appel qu'APRES avoir vu quelqu'un d'autre : un appelant qui attend que
 * l'autre decroche est seul dans la salle, et ce n'est pas la fin de l'appel.
 */
export interface PresenceAppel {
  /** Au moins une autre personne a ete connectee a la salle pendant CET appel. */
  autruiVu: boolean;
  /** Faut-il fermer l'appel maintenant ? */
  fermer: boolean;
}

export const PRESENCE_INITIALE: PresenceAppel = { autruiVu: false, fermer: false };

/**
 * @param avant   ce qu'on savait de cet appel
 * @param distants nombre d'AUTRES personnes connectees a la salle (soi-meme exclu)
 */
export function evaluerPresence(avant: PresenceAppel, distants: number): PresenceAppel {
  const autruiVu = avant.autruiVu || distants >= 1;
  return { autruiVu, fermer: autruiVu && distants === 0 };
}
